import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from '@material-ui/core/Tooltip';
import { InputLabel, Select, MenuItem } from '@material-ui/core';

import React from "react";
import { mdiCar } from '@mdi/js';
import Icon from '@mdi/react';

const ImmobiliseDialog = ({ vehicle, onImmobilise }) => {
	const [open, setOpen] = React.useState(false);
	const [state, setState] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleImmobilise = () => {
		setOpen(false);
		onImmobilise({ _id: vehicle._id, state: state });
	}


	return (
		<>
			<Tooltip title='Immobilise'>
				<IconButton aria-label="delete" onClick={handleClickOpen}
					size='small'
				>
					<Icon path={mdiCar} size={1} />
				</IconButton>
			</Tooltip>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{`Immobilise: ${vehicle.type} - ${vehicle.registration_number} - ${vehicle.registration_state}?`}
					<Typography align="center" color="secondary">You need to have a Immobilser installed in your vehicle.</Typography>
				</DialogTitle>
				<DialogContent>
					<div style={{ display: 'flex', flexDirection: 'column' }}>
						<InputLabel id="demo-simple-select-label">Vehicle Status</InputLabel>
						<Select
							labelId="demo-simple-select-label"
							id="demo-simple-select"
							value={state}
							onChange={e => setState(e.target.value)}
						>
							<MenuItem value={true}>Immobilise</MenuItem>
							<MenuItem value={false}>Mobilise</MenuItem>
						</Select>
					</div>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color="primary">
						Cancel
					</Button>
					<Button onClick={handleImmobilise} color="primary">
						Confirm
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default ImmobiliseDialog;
